var _circle, _rect, _path, _rect2, _path2, _path3, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHubungitraderIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#F2F5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.8867,
    y: 13.6602,
    width: 79.2453,
    height: 104.151,
    rx: 4.90003,
    fill: "url(#paint0_linear_1792_145752)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9814 11.9623C61.9814 9.77397 63.7554 8 65.9437 8V8C68.132 8 69.906 9.77397 69.906 11.9623V14.7925H61.9814V11.9623Z",
    fill: "url(#paint1_linear_1792_145752)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5469,
    y: 21.585,
    width: 67.9246,
    height: 88.3019,
    rx: 4.90003,
    fill: "url(#paint2_linear_1792_145752)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5472 96.3027L92.5472 102.657L40.4717 102.657L40.4717 96.3027L92.5472 96.3027Z",
    fill: "url(#paint3_linear_1792_145752)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2637 13.6602H85.7543V18.1107C85.7543 20.6546 83.6921 22.7168 81.1482 22.7168H51.8697C49.3259 22.7168 47.2637 20.6546 47.2637 18.1107V13.6602Z",
    fill: "url(#paint4_linear_1792_145752)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.736,
    cy: 107.622,
    r: 20.3774,
    fill: "url(#paint5_linear_1792_145752)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6201 122.319V122.269C88.6201 117.228 92.7066 113.141 97.7475 113.141H106.875C111.916 113.141 116.002 117.228 116.002 122.269V123.09C112.437 126.151 107.802 128 102.736 128C97.2564 128 92.2822 125.837 88.6201 122.319Z",
    fill: "#3EE78D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.613 102.189C109.613 106.221 106.344 109.491 102.311 109.491C98.2784 109.491 95.0093 106.221 95.0093 102.189C95.0093 98.1559 98.2784 94.8867 102.311 94.8867C106.344 94.8867 109.613 98.1559 109.613 102.189Z",
    fill: "#3EE78D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5472 32.9053L92.5472 39.2595L40.4717 39.2595L40.4717 32.9053L92.5472 32.9053Z",
    fill: "url(#paint6_linear_1792_145752)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5472 48.7549L92.5472 55.1091L40.4717 55.1091L40.4717 48.7549L92.5472 48.7549Z",
    fill: "url(#paint7_linear_1792_145752)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5472 64.6035L92.5472 70.9578L40.4717 70.9578L40.4717 64.6035L92.5472 64.6035Z",
    fill: "url(#paint8_linear_1792_145752)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5472 80.4531L92.5472 86.8074L40.4717 86.8074L40.4717 80.4531L92.5472 80.4531Z",
    fill: "url(#paint9_linear_1792_145752)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1792_145752",
    x1: 69.0516,
    y1: 139.321,
    x2: 69.0516,
    y2: 30.5408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#2144C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1792_145752",
    x1: 64.4287,
    y1: 5.0283,
    x2: 65.9514,
    y2: 16.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11256D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1792_145752",
    x1: 68.6882,
    y1: 144.5,
    x2: 70.4997,
    y2: 48.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1792_145752",
    x1: 29.5371,
    y1: 97.3326,
    x2: 80.2338,
    y2: 97.3326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1792_145752",
    x1: 59.1505,
    y1: 9.69789,
    x2: 59.7165,
    y2: 25.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11256D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1792_145752",
    x1: 104.043,
    y1: 128.219,
    x2: 104.043,
    y2: 93.8506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1792_145752",
    x1: 29.5371,
    y1: 33.9352,
    x2: 80.2338,
    y2: 33.9352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1792_145752",
    x1: 29.5371,
    y1: 49.7848,
    x2: 80.2338,
    y2: 49.7848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1792_145752",
    x1: 29.5371,
    y1: 65.6334,
    x2: 80.2338,
    y2: 65.6334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1792_145752",
    x1: 29.5371,
    y1: 81.483,
    x2: 80.2338,
    y2: 81.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubungitraderIc);
export default __webpack_public_path__ + "static/media/hubungitrader-ic.c314111a04b8d1cea14d2da5e895671c.svg";
export { ForwardRef as ReactComponent };